import axios from 'axios'
import convert from 'xml-js'
import { AddOptionalHeader } from '../../plugins/axios'

export const companiesArticles = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    readArticles(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readArticlesSuccess(state, payload) {
      const data = payload.map(function (item) {
        const attributes = {
          title: item.title._text,
          link: item.link._text,
          img_src: $(item.description._text).find('img').attr('src'),
        }
        return attributes
      })
      state.data = { data: data }
      state.loading = false
    },
    readArticlesFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  actions: {
    readArticles({ commit }) {
      commit('readArticles')
      axios.interceptors.request.eject(AddOptionalHeader)
      axios
        .get('https://lab.kutikomi.com/feed/')
        .then(res => {
          const json = JSON.parse(convert.xml2json(res.data, {compact: true}))
          commit('readArticlesSuccess', json.rss.channel.item)
        })
        .catch(err => {
          commit('readArticlesFailure', err)
          console.error(err)
        })
    }
  }
}
